import React from "react";
import { Doughnut } from "react-chartjs-2";
import { configureChartFont } from "../../utils/chartFont";

const DoughnutChart = ({ data: chartData }) => {
  configureChartFont();

  const data = {
    labels: chartData.map((l) => l.label),
    datasets: [
      {
        backgroundColor: chartData.map((l) => l.color),
        borderColor: "white",
        borderWidth: 1,
        data: chartData.map((l) => l.value),
      },
    ],
  };

  const options = {
    title: {
      display: false,
    },
    plugins: {
      legend: false,
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
